<div class="h-screen w-screen flex bg-gray-100 dark:bg-gray-950 overflow-hidden">
  <!-- Sidebar handles historic sessions and start of a new session -->
  <app-sidebar
    [sessions]="sessions"
    [currentId]="activeId"
    [openMenuId]="openMenuId"
    (newSession)="handleNewSession()"
    (onSessionSelected)="onSessionSelected($event)"
    (onDeleteSession)="onDeleteSession($event)"
    (toggleMenu)="toggleMenu(null, $event)">
  </app-sidebar>
    
  <!-- Main Chat Area -> dynamically loads /chat pages -->
  <div class="flex-1 flex flex-col relative w-full h-full max-w-full min-w-0 bg-white dark:bg-gray-900">
    <router-outlet></router-outlet>
  </div>

  <app-notification-banners></app-notification-banners>

  <!-- Delete Confirmation Modal -->
  <app-delete-confirmation-modal
    [isOpen]="isDeleteModalOpen"
    [title]="sessionToDelete?.title"
    (close)="cancelDelete()"
    (confirm)="confirmDelete()">
  </app-delete-confirmation-modal>
</div>
